import { render, staticRenderFns } from "./Splashscreen.vue?vue&type=template&id=c6b06034&scoped=true&"
import script from "./Splashscreen.vue?vue&type=script&lang=js&"
export * from "./Splashscreen.vue?vue&type=script&lang=js&"
import style0 from "./Splashscreen.vue?vue&type=style&index=0&id=c6b06034&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b06034",
  null
  
)

export default component.exports